import { render, staticRenderFns } from "./grayScaleTest.vue?vue&type=template&id=19680fa1&scoped=true&"
import script from "./grayScaleTest.vue?vue&type=script&lang=js&"
export * from "./grayScaleTest.vue?vue&type=script&lang=js&"
import style0 from "./grayScaleTest.vue?vue&type=style&index=0&id=19680fa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19680fa1",
  null
  
)

export default component.exports